import { FetchBatchesFromProcedureCommandHandler } from '@/Application/Batch'
import { StandardProcedureFactory, SingleProcedureRepository } from '@/Domain/Procedures'
import { AxiosProcedureRepository } from '@/Infrastructure/Procedures/Persistence/Axios'
import { InMemoryProcedureRepository } from '@/Infrastructure/Procedures/Persistence/InMemory'
import { AxiosBatchRepository, AxiosBatchFactory } from '@/Infrastructure/Batch/Persistence/Axios'
import { InMemoryBatchRepository } from '@/Infrastructure/Batch/Persistence/InMemory'
import { BatchRepository } from '@/Domain/Batch'
import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'

export class FetchBatchesFromProcedureCommandHandlerProvider
implements CommandHandlerProvider<FetchBatchesFromProcedureCommandHandler> {
  provide (): FetchBatchesFromProcedureCommandHandler {
    const handler = new FetchBatchesFromProcedureCommandHandler(
      this.getProcedureRepository(),
      this.getBatchRepository()
    )
    return handler
  }

  private getBatchRepository (): BatchRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryBatchRepository()
    }
    return new AxiosBatchRepository(
      new AxiosApiClient(new SessionTokenStorage()),
      new AxiosBatchFactory()
    )
  }

  private getProcedureRepository (): SingleProcedureRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryProcedureRepository()
    }
    return new AxiosProcedureRepository(new AxiosApiClient(new SessionTokenStorage()), new StandardProcedureFactory())
  }
}
